import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const linkStyles = tv({
  slots: {
    base: `
      iris:flex
      iris:min-h-(--comp-size-height-link)
      iris:w-max
      iris:min-w-(--comp-size-height-link)
      iris:items-center
      iris:justify-center
      iris:gap-(--comp-space-gap-link-icon)
      iris:font-(family-name:--comp-type-font-link)
      iris:tracking-(--comp-type-tracking-link)
      iris:text-(--comp-color-content-link-rest)
      iris:duration-(--comp-motion-duration-link)
      iris:ease-(--comp-motion-easing-link)
      iris:hover:text-(--comp-color-content-link-hover)
      iris:focus-visible:rounded-xs
      iris:active:text-(--comp-color-content-link-pressed)
    `,
    icon: ""
  },
  variants: {
    variant: {
      inline: {
        base: "iris:underline"
      },
      standalone: {
        base: `
          iris:no-underline
          iris:hover:underline
          iris:active:underline
        `
      }
    },
    inverse: {
      false: {
        base: focusStyles.default
      },
      true: {
        base: `
          iris:text-(--comp-color-content-link-inverse-rest)
          iris:hover:text-(--comp-color-content-link-inverse-hover)
          iris:active:text-(--comp-color-content-link-inverse-pressed)
          ${focusStyles.inverse}
        `
      }
    },
    weight: {
      regular: {
        base: "iris:font-(--comp-type-weight-link-regular)"
      },
      bold: {
        base: "iris:font-(--comp-type-weight-link-bold)"
      }
    },
    size: {
      md: {
        base: "iris:text-(length:--comp-type-size-link-md)",
        icon: "iris:w-(--comp-size-icon-link-md)"
      },
      sm: {
        base: "iris:text-(length:--comp-type-size-link-sm)",
        icon: "iris:w-(--comp-size-icon-link-sm)"
      },
      xs: {
        base: `iris:text-(length:--comp-type-size-link-xs)`,
        icon: `iris:w-(--comp-size-icon-link-xs)`
      },
      xxs: {
        base: `iris:text-(length:--comp-type-size-link-xxs)`,
        icon: `iris:w-(--comp-size-icon-link-xxs)`
      }
    },
    iconPosition: {
      left: {
        base: `iris:flex-row`
      },
      right: {
        base: `iris:flex-row-reverse`
      }
    }
  },
  defaultVariants: {
    variant: "inline",
    size: "md",
    weight: "regular",
    iconPosition: "left"
  }
});

export { linkStyles as default };
